module.exports = __webpack_public_path__ + "img/模版@2x.d0ccbd63.png";